import React, { ReactElement } from 'react';
import { Link, Td, Tr } from 'idsk-react-components';
import routes from '../../../../routing/routes';
import SledovatelDeleteButton
  from '../../LegislativnyMaterialDetail/component/Actions/component/SledovatelDeleteButton';
import './sledovanyLegislativnyMaterialListTable.scss';
import splitCisloLegMaterialu from '../../../../function/splitCisloLegMaterialu';
import LegislativnyMaterialFilterListItem
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialFilterListItem';

interface Props {
  legMaterial: LegislativnyMaterialFilterListItem;
  reloadMaterialPage: () => void;
}

const LegislativnyMaterialListTable = ({
  legMaterial,
  reloadMaterialPage,
}: Props): ReactElement => {
  const {
    type,
    year,
    index,
  } = splitCisloLegMaterialu(legMaterial.cisloLp);
  return (
    <Tr key={legMaterial.uuid}>
      <Td>{legMaterial.typNazov}</Td>
      <Td>{legMaterial.cisloLp}</Td>
      <Td>
        <Link
          className="nazov-link"
          to={routes.procesy.detail.withParams(type, year, index)}
        >
          {legMaterial.nazov}
        </Link>
      </Td>
      <Td>
        {legMaterial.stadium.nazov}
      </Td>
      <Td>
        <SledovatelDeleteButton
          buttonText="Zrušiť sledovanie"
          buttonStyle="link-negative"
          size="small"
          icon={false}
          legMaterialUuid={legMaterial.uuid}
          updateMaterial={reloadMaterialPage}
        />
      </Td>
    </Tr>
  );
};

export default LegislativnyMaterialListTable;
